<template>
    <a-card>
        <div style="float: right;">
            <div class="table-toolbar">
                <a-button type="primary" @click="onEdit">编辑
                    <template #icon>
                        <form-outlined />
                    </template>
                </a-button>
            </div>
        </div>
        <div class="top">
<!--            <div class="imgBox">
                <img style="width: 100%;height: 100%;"
                     :src="detail.companyLogo ? getImg(detail.companyLogo) : '@/assets/img/defaultPhoto.png'" />
            </div>-->
            <div class="rightBox">
                <div class="topBox">
                    <p class="name">{{ detail.unitName }}</p>
                    <p class="nameRight">注册用户：事业单位/国企</p>
                </div>
<!--                <div class="second">
                    &lt;!&ndash; <div class="address">地址：{{ detail.provject }}{{ detail.detailedAddress }}</div> &ndash;&gt;
                    <div class="name">联系人：{{ detail.linkPerson }} </div>
                    <div class="name"> 联系电话：{{ detail.linkWay }}</div>
                </div>-->
            </div>
        </div>
        <a-descriptions bordered :column="2">
            <a-descriptions-item label="统一社会信用代码" :span="2">{{ detail.licence }}</a-descriptions-item>
          <a-descriptions-item label="法人">{{ detail.legalPersonName }}</a-descriptions-item>
          <a-descriptions-item label="法人电话">{{ detail.legalPersonPhone }}</a-descriptions-item>
          <a-descriptions-item label="单位地址" :span="2">{{ detail.address }}</a-descriptions-item>
            <a-descriptions-item label="法人身份证" :span="2">
                <file-upload v-model:value="detail.legalPersonCard" :showBtn="false" disabled />
            </a-descriptions-item>
          <a-descriptions-item label="法人证书/营业执照" :span="2">
            <file-upload v-model:value="detail.legalPersonCredentials" :showBtn="false" disabled />
          </a-descriptions-item>
        </a-descriptions>

    </a-card>
    <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="getCorpInfo" />
</template>

<script>
import UserModal from './components/UserModal';
import { govInstitution } from "@/api/projectReviewService";
import { file_service } from "@/api/adminService";

import { dictMixin } from "@/mixins";
import { sys_policy } from "@/api/policyService";

export default {
    name: "index",
    mixins: [dictMixin],
    components: {
        UserModal
    },
    data() {
        return {

            detail: {},
            listKeyField: "id",
        }
    },
    mounted() {
        this.getCorpInfo();
        this.getTwoCode()
    },
    methods: {
        getCorpInfo() {
            this.getAction({
                url: govInstitution.detail
            }).then(res => {
                this.detail = {
                    ...res,
                }
            })
        },
        getTwoCode() {
            this.getAction({
                url: sys_policy.getErCode
            }).then(res => {
                this.$ls.set('erweimaCode', res);
                // this.erweimaCode = res
            })
        },
        onEdit() {
            this.onShowModal('userModal', this.detail);
        },
        onShowModal(refName, data = {}) {
            const refEle = this.$refs[refName];
            refEle.form = Object.assign({}, data);
            refEle.visible = true;
        },
        getImg(imgUrl) {
            return file_service.imagesWeb(imgUrl)
        },
    }
}
</script>

<style scoped lang="less">
.top {
    overflow: hidden;
    margin-bottom: 10px;

    .imgBox {
        float: left;
        margin-right: 20px;
        width: 100px;
        height: 100px;
    }

    .rightBox {
        float: left;
        color: #333;
        width: 70%;

        .topBox {
            overflow: hidden;
            padding-bottom: 10px;
            border-bottom: 1px dashed #dedede;

            .name {
                float: left;
                font-weight: 700;
                font-size: 24px;
            }

            .nameRight {
                float: left;
                margin-left: 25px;
                margin-top: 10px;
            }
        }

        .second {
            font-size: 16px;
            margin-top: 10px;
            display: flex;
            justify-content: space-around;

            .name {
                width: 50%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
            }
        }
    }
}
</style>
